import Employee from '@/classes/Employee';
class EmployeeCollectionAdmin {
    employees = [];
    constructor(employees) {
        this.employees = this.convertToEmployeesCollection(employees);
    }
    convertToEmployeesCollection(employees) {
        const employeesArray = [];
        employees.forEach((emp) => {
            const tempEmps = new Employee(emp);
            employeesArray.push(tempEmps);
        });
        return employeesArray;
    }
    getEmployee(userId) {
        return this.employees.filter((employee) => {
            return employee.userId === userId;
        });
    }
}
export default EmployeeCollectionAdmin;
